import { gql } from '@apollo/client/core/index.js'

export const queries = {
  GET_ADVERTISERS: gql`
  query SELECT_GetAdvertisers(
    $filter: AdvertiserFilterInput, 
    $page: Int, 
    $limit: Int, 
    $sort_by: String, 
    $sort_order: SortEnum,
  ) {
    getAdvertisers(
      filter: $filter,
      page: $page,
      limit: $limit,
      sort_by: $sort_by,
      sort_order: $sort_order,
    ) {
      count
      rows {
        advertiser_id
        company_name
        company_url
        last_login_time_for_user
        logo
      }
    }
  }
`,
}
